/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const ButtonLargeWeb = ({
  primarioActive,
  primarioInactive,
  secundarioActive,
  secundarioInactive,
  terciarioActive,
  iconLeft,
  iconRigth,
  terciarioInactive,
  className,
  text = "Estado normal",
}) => {
  return (
    <div className={`button-large-WEB ${className}`}>
      <div className="div">
        <div className="text">{text}</div>
      </div>
    </div>
  );
};

ButtonLargeWeb.propTypes = {
  primarioActive: PropTypes.bool,
  primarioInactive: PropTypes.bool,
  secundarioActive: PropTypes.bool,
  secundarioInactive: PropTypes.bool,
  terciarioActive: PropTypes.bool,
  iconLeft: PropTypes.bool,
  iconRigth: PropTypes.bool,
  terciarioInactive: PropTypes.bool,
  text: PropTypes.string,
};
